import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IonicModule, ToastController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ConnectionManagerService } from 'src/app/services/ConnectionManager/connection-manager.service';
import { PartialRegistrationComponent } from '../partial-registration/partial-registration.component';
import { Network } from '@capacitor/network';
import { Location } from '@angular/common';


@Component({
  standalone: true,
  selector: 'app-register-pending',
  imports: [IonicModule, CommonModule],
  templateUrl: './register-pending.component.html',
  styleUrls: ['./register-pending.component.scss'],
})
export class RegisterPendingComponent implements OnInit {
  queuedRegistrations: any[] = [];
  isOnline = navigator.onLine;

  constructor(
    private route: ActivatedRoute,
    private toastCtrl: ToastController,
    public connectionManagerService: ConnectionManagerService,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.loadQueuedRegistrations();
    this.listenToConnectionChanges();
  }

  private listenToConnectionChanges(): void {
    // window.addEventListener('online', () => {
    //   this.isOnline = true;
    //   this.presentToast('✅ Back online! Processing queued registrations.', 'success');
    //   this.processQueuedRegistrations();
    // });
    Network.addListener("networkStatusChange", (e) => {
      if (e.connected) {
        this.isOnline = true;
        this.presentToast("You're back online. We're completing your registration.", 'success');
        // ✅ Go back one page
        this.location.back();
      } else {
        this.isOnline = false;
        this.presentToast("You're offline. Your registration is saved and will resume when you're back online.", 'warning');
      }

    });


    // If already online and there are queued items (e.g., refresh case)
    if (this.isOnline && this.queuedRegistrations.length > 0) {
      this.processQueuedRegistrations();
    }
  }

  private loadQueuedRegistrations(): void {
    const raw = localStorage.getItem('offline_registrations');
    if (!raw) return;

    try {
      const queue = JSON.parse(raw);
      if (Array.isArray(queue)) {
        this.queuedRegistrations = queue;
      }
    } catch (error) {
      return error;
    }
  }

  private processQueuedRegistrations(): void {
    if (!this.queuedRegistrations.length) return;

    this.queuedRegistrations.forEach((data, index) => {
      setTimeout(() => {
      }, index * 1000); // slight delay between each attempt
    });

    // Clear queue from localStorage
    localStorage.removeItem('offline_registrations');
    this.queuedRegistrations = [];
  }

  async presentToast(message: string, color: 'success' | 'warning' | 'danger') {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color,
      position: 'bottom',
    });
    toast.present();
  }

}
